import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Filters,
  License,
  LicenseBundleResponse,
  LicenseBundleToUpdate,
  LicenseResponse,
  RenewOfflineLicenseKeyResponse,
  ResultList,
} from '@app/models';
import { APIURL } from '@app/shared';
import { Subject, lastValueFrom, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LicensesService {
  reloadLicenses$ = new Subject<void>();
  updateLicenseBundleById$: Subject<LicenseBundleToUpdate> = new Subject<LicenseBundleToUpdate>();

  private BASE_URL = `${APIURL}licenses`;

  constructor(private http: HttpClient) {}

  private url(endpoint: string): string {
    return `${this.BASE_URL}/${endpoint}`;
  }

  async list(filters: Filters): Promise<ResultList<License>> {
    const url = this.url('list');
    const res = await lastValueFrom(this.http.post<ResultList<License>>(url, { filters }));
    res.result = res.result.map((license) => new License(license));
    return res;
  }

  offlineActivation(
    licenseKey: string,
    selectedFile: File,
  ): Promise<{ licenseData: { licenseBundle?: LicenseBundleResponse; licenses: LicenseResponse[] } }> {
    const url = this.url('offlineActivation');

    const formData = new FormData();
    formData.append(
      'jsonParams',
      JSON.stringify({
        licenseKey,
      }),
    );
    formData.append('file', selectedFile);

    return lastValueFrom(
      this.http
        .post<{ licenseData: { licenseBundle?: LicenseBundleResponse; licenses: LicenseResponse[] } }>(url, formData, {
          headers: { 'X-Multi-Part': 'true', 'Access-Control-Allow-Origin': '*' },
        })
        .pipe(
          map((res) => {
            return {
              licenseData: {
                licenses: res?.licenseData?.licenses?.map((license) => new LicenseResponse(license)),
                licenseBundle: res?.licenseData?.licenseBundle ? new LicenseBundleResponse(res.licenseData.licenseBundle) : undefined,
              },
            };
          }),
        ),
    );
  }

  renewOfflineLicenseKey(licenseId: string) {
    return this.http.post<RenewOfflineLicenseKeyResponse>(`${this.BASE_URL}/renewOfflineLicenseKey`, {
      licenseId,
    });
  }
}
